import './HomePage.css'

const HomePage = () => {
  return (
    <main className='home-page'>
        <h1>FORGE</h1>
    </main>
  )
}

export default HomePage